module.exports = __webpack_public_path__ + "static/img/newsDelete.e7cc66b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/newsDelete.png
// module id = 32
// module chunks = 2 4 5 11 12 13 16